import { buildURL } from 'react-imgix';
import parseImgix from './parseImgix';

export const buildCardImageUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;

  const parsed = parseImgix(url);
  if (!parsed) return undefined;

  return buildURL(parsed, {
    trim: 'auto',
    fit: 'crop',
    crop: 'top',
    ar: '4:3',
    w: 600,
    auto: 'format,compress',
    q: 70,
  });
};
